import { render, staticRenderFns } from "./AreaTreeSelect.vue?vue&type=template&id=35c27bc0&"
import script from "./AreaTreeSelect.vue?vue&type=script&lang=ts&"
export * from "./AreaTreeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AreaTreeSelect.vue?vue&type=style&index=0&id=35c27bc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports